The main container for the history panel
<div class="chat-history-panel">
  <!-- The header section with the "New Chat" button -->
  <div class="history-panel-header">
    <button mat-stroked-button class="new-chat-btn" (click)="newChat()">
      <mat-icon>add</mat-icon>
      <span>New Chat</span>
    </button>
  </div>

  <!-- The scrollable list of chat history from API -->
  <div class="history-list">
    <div
      *ngFor="let item of chatHistory"
      class="history-item"
      (click)="selectChatThread(item.chatThreadId)">
      <div class="history-item-title">
        <mat-icon>chat_bubble_outline</mat-icon>
        <span>{{ item.question }}</span>
      </div>
      <button mat-icon-button (click)="deleteConversation($event, item.chatThreadId)" matTooltip="Delete Conversation">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  </div>
</div>
